import React from 'react';
import Logs from './logs';
import useHistorical from '../../../modules/historical/useHistorical';
import { ILog, MapLog } from '../../../models';
import { mapLogDefault } from '../../../modules/historical';

type Props<T extends ILog> = {
  mapLog?: MapLog<T>;
}
export const LogMappedList = <T extends ILog>({
  mapLog = mapLogDefault,
}: Props<T>) => {
  const { logs } = useHistorical<T>();
  const mappedLogs = (logs || []).map(mapLog);
  return (<Logs logs={mappedLogs} />);
};

export default LogMappedList;
